import { createContext } from 'react';

var SystemContext = createContext({});

export { SystemContext };
